import * as React from 'react';
import { useTranslation } from 'react-i18next';

export const ComparisonMenuEmpty = () => {
    const { t } = useTranslation();
    return (
        <div className="empty-compare-objects">
            {t('Объекты для сравнения отсутствуют')}
        </div>
    );
};
